import uniqid from 'uniqid';
import * as actions from '../../types';
import CMX from '../../../api';
import {dialogOpen, dialogClose, dialogAlert} from '../dialogs';
import { getCandybarSelectedItemId } from '../../../reducers';

export const candybarFetch = params => (dispatch, getState) => {
  dispatch(candybarIsLoading(true));

  CMX.get('candybar/catalog', params)
      .then(data => dispatch(candybarFetchSuccess(data)))
      .then(() => dispatch(candybarIsLoading(false)))
      .catch(() => dispatch(candybarFetchError()));
}

export const candybarIsLoading = (isLoading) => ({
  type: actions.CHECKOUT_CANDYBAR_IS_LOADING,
  isLoading,
});

export const candybarFetchError = () => ({
  type: actions.CHECKOUT_CANDYBAR_FETCH_ERROR,
});

export const candybarFetchSuccess = (data) => ({
  type: actions.CHECKOUT_CANDYBAR_FETCH_SUCCESS,
  data,
});

export const candybarCategorySelect = (categoryId) => ({
  type: actions.CHECKOUT_CANDYBAR_CATEGORY_SELECT,
  categoryId,
});

export const candybarItemSave = (item, unitId, config) => dispatch => {
  dispatch({
    type: actions.CHECKOUT_CANDYBAR_ITEM_SAVE,
    item,
    unitId: unitId || uniqid(),
    config,
  });
  dispatch(candybarItemEditCancel());
};

export const candybarItemSelect = (itemId, unitId = null) => ({
  type: actions.CHECKOUT_CANDYBAR_ITEM_SELECT,
  itemId,
  unitId,
});

export const candybarItemEditCancel = () => ({
  type: actions.CHECKOUT_CANDYBAR_ITEM_EDIT_CANCEL
});

  // dispatch(dialogOpen({
  //   message: '¿Estás seguro que deseas descartar las modificaciones realizadas?',
  //   buttons: [
  //     {
  //       label: 'Descartar cambios',
  //       onClick: (dialog) => {
  //         dispatch({
  //           type: actions.CHECKOUT_CANDYBAR_ITEM_EDIT_CANCEL,
  //           itemId,
  //         });
  //         dispatch(dialogClose(dialog.id));
  //       }
  //     },
  //     {
  //       label: 'Seguir editando',
  //       primary: true,
  //       onClick: (dialog) => {
  //         dispatch(dialogClose(dialog.id));
  //       }
  //     },
  //   ]
  // }));

export const candybarItemRemove = (itemId, unitId) => ({
  type: actions.CHECKOUT_CANDYBAR_ITEM_REMOVE,
  itemId,
  unitId,
});

export const candybarItemFavAdd = (itemId, add) => ({
  type: add ? actions.CHECKOUT_CANDYBAR_ITEM_FAV_ADD : actions.CHECKOUT_CANDYBAR_ITEM_FAV_REMOVE,
  itemId,
});